import React from 'react'
export default function Project({project}) {
  return (
    <div className="w-full">
        <div className="animate animate__animated animate__fadeIn">
            <img className="h-56 w-full object-cover rounded-lg" src={project?.cover} alt="project cover image" />
        </div>
        <div className="py-4 space-y-3">
            <h2 className="text-xl md:text-2xl font-light text-white">{project?.name}</h2>
            <div className="flex space-x-2">
                <a target="_blank" rel="noreferrer" href={project?.liveURL} className="blog_text border-2 border-transparent hover:border-b-rose-400 duration-200">Project Link</a>
            </div>
        </div>
    </div>
  )
}
